import {
  Commitment,
  Relationship,
} from "@/services/backend/relationships/types/relationship";
import { useEffect, useState } from "react";
import { useRelationshipsRelationshipCopyToFutureCommitmentsMutation } from "@/services/backend/relationships/api/service";
import { toast } from "sonner";
import { Dialog, DialogContent } from "@/shared/components/ui/dialog";
import {
  CommonDialogFooter,
  CommonDialogHeader,
  CommonDialogTrigger,
} from "@/shared/components/dialog/dialog-common";
import { Copy } from "lucide-react";
import t from "@/lang/lang";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";

export function CopyToFutureCommitmentsDialog({
  relationship,
  commitment,
}: {
  relationship: Relationship;
  commitment: Commitment;
}) {
  const [open, setOpen] = useState(false);
  const [patch, { isLoading, error, reset, isSuccess }] =
    useRelationshipsRelationshipCopyToFutureCommitmentsMutation();

  useEffect(() => {
    if (isSuccess) {
      reset();
      setOpen(false);
      toast.success(
        "Behandlung für alle zukünftigen Sollstellungen übernommen",
      );
    }
  }, [isSuccess, reset]);

  const doCopy = () => {
    if (isLoading) {
      return;
    }

    patch({
      id: relationship.id,
      commitmentId: commitment.id,
    });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <CommonDialogTrigger
        variant="outline"
        icon={Copy}
        label={t("Für zukünftigen übernehmen")}
      />
      <DialogContent>
        <CommonDialogHeader
          title={t("Für alle zukünftigen Sollstellungen übernehmen?")}
          description={t(
            "Die Behandlung wird für alle zukünftigen Sollstellungen übernommen.",
          )}
        />
        <RTKQueryErrorAlert error={error} onDismiss={reset} />
        <CommonDialogFooter isLoading={isLoading} onClickAction={doCopy} />
      </DialogContent>
    </Dialog>
  );
}
